import React from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import {AccentColorOptions} from 'epic-ue-theme';
import {AnimateOnViewWrap} from '../../wraps';
import {GridContainer, CenteredGrid, LineTextBlock, VerticalSpacer} from '..';
import {PluginCard, PluginCardProps} from './PluginCard';

const Styled = styled.div`
    .description .paragraph {
        color: ${(p) => p.theme.palette.text.secondary};
    }

    .cardItemOuter:nth-child(odd) {
        .cardItemInner {
            background-color: ${(p) => p.theme.palette.background.paper};
        }
    }

    .cardItemOuter:nth-child(even) {
        .cardItemInner {
            background-color: ${(p) =>
                p.theme.ifLight(p, p.theme.palette.common.white, p.theme.palette.common.black)};
        }
    }
    & .ue-centered-grid {
        width: initial;
    }
`;

export interface PluginCardListProps {
    accentColor?: AccentColorOptions;
    cards?: PluginCardProps[];
    description?: string;
    heading?: string;
    pluginsLabel?: string;
    pluginsLabelPlural?: string;
    osLabel?: string;
    desktopSearchLabel?: string;
    mobileSearchLabel?: string;
    filterLabel?: string;
    noResultsLabel?: string;
    mobileFilterTitle?: string;
}

export const PluginCardList = (props: PluginCardListProps): JSX.Element => {
    const {heading, accentColor, cards = []} = props;

    const noPadding = {padding: 0};
    const noMargin = {margin: 0};
    let PluginCardProps: PluginCardProps;

    return (
        <Styled>
            <GridContainer>
                {heading && (
                    <Grid item xs={12} sm={true}>
                        <LineTextBlock headline={heading} accentColor={accentColor} disableAnim />
                        <VerticalSpacer variant="custom" spacing={3} downSmSpacing={2} />
                    </Grid>
                )}

                <CenteredGrid style={noMargin}>
                    {cards.length ? (
                        <>
                            {cards.map((cardProps, index) => {
                                if (
                                    cardProps.button &&
                                    !cardProps.button.href?.match('twinmotion.com')
                                ) {
                                    cardProps.button.target = '_blank';
                                }
                                return (
                                    <Grid
                                        className="cardItemOuter"
                                        item
                                        xs={12}
                                        md={4}
                                        key={`card-grid-item-${index}`}
                                        style={noPadding}>
                                        <AnimateOnViewWrap
                                            translateY={30 + (index % 3) * 10}
                                            delay={(index % 3) * 0.3}>
                                            <div className="cardItemInner">
                                                <PluginCard
                                                    {...cardProps}
                                                    accentColor={accentColor}
                                                    {...PluginCardProps}
                                                />
                                            </div>
                                        </AnimateOnViewWrap>
                                    </Grid>
                                );
                            })}
                        </>
                    ) : (
                        ''
                    )}
                </CenteredGrid>
            </GridContainer>
        </Styled>
    );
};
